export const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const resizeImage = ({
  maxWidth = 1920,
  // maxHeight = false,
  quality = 90,
  file,
}) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    // eslint-disable-next-line
    reader.onload = function() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const image = new Image();
      // eslint-disable-next-line
      image.onload = async function() {
        const { width, height } = image;

        canvas.width = Math.min(maxWidth, width);
        canvas.height = (height / width) * canvas.width;

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        const data = canvas.toDataURL(file.type, quality / 100);
        const changedFile = dataURLtoFile(data, file.name);

        resolve({ data, file: changedFile });
      };

      image.src = reader.result;
    };
    // eslint-disable-next-line
    reader.onerror = function(error) {
      reject(error);
    };
  });

export const uploadToGoogleCloud = (type, folder, file) =>
  // eslint-disable-next-line
  new Promise((resolve, reject) => {
    try {
      const data = new FormData();
      data.append('file', file);

      return fetch(`/api/media/upload/${type}/${folder}`, {
        method: 'POST',
        body: data,
      })
        .then(res => res.json())
        .then(res => {
          resolve(res.url);
        })
        .catch(e => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
